import type { FaireProductEntity } from "../../entity_types/product";

export const p_x5f3apc235: FaireProductEntity = {
  token: "p_x5f3apc235",
  type: "product",
  name: "(FLAT)ROUGH - MIXED STONES (6 KINDS) 0.25-0.5''",
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl: "https://cdn.faire.com/fastly/f92ee3e24eb2f1dd0a4a7876caef511969d9e8f0dd91fe09e1e5a30b4920924e.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.52,
  description: "At Oceanic Linkways Inc, we're proud to offer our (Flat) Rough - Mixed Stones. These six distinct types of stones, each sized between 0.25-0.5'', are a versatile addition to any collection. As a leading wholesaler of gemstones, we source our stones from 19 countries, ensuring quality and diversity. Ideal for home decor, gifting, or spiritual practices, explore the power and beauty of nature with our carefully selected mixed stones.",
  tags: [],
  msrpDollars: 62.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:43.243Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
